<template>
  <div
    class="flex bg-white gap-2 box-shadow: 0px 5% 10% rgba(12, 74, 110, 0.07)"
    :class="mainWrapperClass"
  >
    <div v-if="extendedColorSelection" :class="buttonClass">
      <ColorsOptions
        class="scale-[50%] translate-y-[-25%] border-1 border-solid border-secondary-250"
        :class="{ 'translate-x-[25%]': rtl, 'translate-x-[-25%]': !rtl }"
        @action="color => updateModelValue(color)"
      />
    </div>
    <button
      v-for="(color, index) of colors"
      :key="index"
      class="flex justify-center items-center"
      :class="[buttonClass, isClass(color) ? color : '']"
      :style="!isClass(color) ? { backgroundColor: color } : {}"
      @click="updateModelValue(color)"
    >
      <Check v-if="selectedColor === color" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { Check } from 'lucide-vue-next';
import { ColorsOptions } from '@amit/tiptap';

const props = defineProps({
  colors: {
    type: Object as PropType<String[]>,
    required: true,
    default: ['#fffff'],
  },
  extendedColorSelection: {
    type: Boolean,
    default: false,
  },
  rtl: {
    type: Boolean,
    default: false,
  },
  buttonClass: {
    type: String,
    default: 'h-10 w-10',
  },
  mainWrapperClass: {
    type: String,
    default: 'px-5 py-6',
  },
});

const selectedColor = defineModel('selectedColor');

const updateModelValue = (color: string) => {
  selectedColor.value = color;
};

const isClass = (color: string) => {
  return color.startsWith('bg-');
};
</script>

<style scoped>
.list-wrapper {
  box-shadow: none !important;
  border: 1px soild #e3e9f2 !important;
}
.list-wrapper >>> svg {
  transform: scale(2) translateY(-1px) !important;
  outline-color: white !important;
  outline-style: solid !important;
}
</style>
